import { render } from "./main-page.vue?vue&type=template&id=d0a9f818"
import script from "./main-page.vue?vue&type=script&lang=js"
export * from "./main-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__